function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\n\t.st0{fill:#B1C3CC;}\n");

var _ref3 = /*#__PURE__*/React.createElement("path", {
  id: "Combined-Shape",
  className: "st0",
  d: "M17,1c1.1,0,2,0.9,2,2l0,0v14c0,1.1-0.9,2-2,2l0,0H3c-1.1,0-2-0.9-2-2l0,0V3 c0-1.1,0.9-2,2-2l0,0H17z M17,3H3v14h14V3z M7.5,10.5v2h2V14h-2v2H6v-2H4v-1.5h2v-2H7.5z M16,13.7v1.5h-5v-1.5H16z M16,11.2v1.5h-5 v-1.5H16z M14.9,4L16,5.1l-1.4,1.4L16,7.9l-1.1,1.1l-1.4-1.4l-1.4,1.4L11,7.9l1.4-1.4L11,5.1L12.1,4l1.4,1.4L14.9,4z M9.2,5.7v1.5 h-5V5.7H9.2z"
});

var SvgEstimator = function SvgEstimator(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: "new 0 0 20 20"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgEstimator, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/estimator.3b046722.svg";
export { ForwardRef as ReactComponent };